import produce from 'immer';

import {
  ENABLE_SELECTION,
  DISABLE_SELECTION,
  CLEAR_SELECTION_ITEMS,
  ADD_SELECTION_ITEMS,
  SELECT_ITEM,
  UNSELECT_ITEM,
  SELECT_ALL,
  UNSELECT_ALL
} from 'shared/actions/types';

const initialState = {
  selection: {
    enabled: false,
    header: null,
    buttonText: null,
    buttonIcon: null,
    callback: null,
    cancel: null,
    items: {} // {id: bool}
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case ENABLE_SELECTION:
      return produce(state, draft => {
        draft.selection.enabled = true;
        draft.selection.header = action.payload.header;
        draft.selection.buttonText = action.payload.buttonText;
        draft.selection.buttonIcon = action.payload.buttonIcon;
        draft.selection.callback = action.payload.callback;
        draft.selection.cancel = action.payload.cancel;
      });

    case DISABLE_SELECTION:
      return produce(state, draft => {
        draft.selection.enabled = false;
      });

    case CLEAR_SELECTION_ITEMS:
      return produce(state, draft => {
        draft.selection.items = {};
      });

    case ADD_SELECTION_ITEMS:
      return produce(state, draft => {
        const ids = action.payload.map(obj => obj.id);
        ids.forEach(id => draft.selection.items[id] = false);
      });

    case SELECT_ITEM:
      return produce(state, draft => {
        draft.selection.items[action.payload.id] = true;
      });

    case UNSELECT_ITEM:
      return produce(state, draft => {
        draft.selection.items[action.payload.id] = false;
      });

    case SELECT_ALL:
      return produce(state, draft => {
        for (let id in draft.selection.items) {
          draft.selection.items[id] = true;
        }
      });

    case UNSELECT_ALL:
      return produce(state, draft => {
        for (let id in draft.selection.items) {
          draft.selection.items[id] = false;
        }
      });

    default:
      return state;
  }
}


